import React from 'react';
import {Table, Container, Header, Segment, Modal, Grid} from 'semantic-ui-react';

const categoryNames = {
    'Cash_Split' : 'PT Pay',
    'Claim_pay' : 'INS Pay'
}
const PreviousPayDataDetails = (props) => {
    const {
        handlePreviousPayDetailsModal,
        payData,
        providerPayByPractice,
    } = props;


    const renderProviderChangeTable = (data, title) => (
        <Segment>
            <Header as="h3">{title}</Header>
            <Table celled striped>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>PatNum</Table.HeaderCell>
                        <Table.HeaderCell>PayNum</Table.HeaderCell>
                        <Table.HeaderCell>Category</Table.HeaderCell>

                        <Table.HeaderCell>prev Abbr</Table.HeaderCell>
                        <Table.HeaderCell>Payment Amount</Table.HeaderCell>
                        <Table.HeaderCell>Payment Date</Table.HeaderCell>
                        <Table.HeaderCell>Entry Date</Table.HeaderCell>
                        <Table.HeaderCell>Pre ProcDate</Table.HeaderCell>

                        <Table.HeaderCell>Live Abbr</Table.HeaderCell>
                        <Table.HeaderCell>Payment</Table.HeaderCell>
                        <Table.HeaderCell>Live ProcDate</Table.HeaderCell>

                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {data.length === 0 ? (
                        <Table.Row>
                            <Table.Cell colSpan="3" textAlign="center">
                                No records found.
                            </Table.Cell>
                        </Table.Row>
                    ) : (
                        data.map((item, idx) => (
                            <Table.Row key={idx}>
                                <Table.Cell>{item.live.PatNum}</Table.Cell>
                                <Table.Cell>{item.live.paynum}</Table.Cell>
                                <Table.Cell>{categoryNames[item.live.Category]}</Table.Cell>

                                <Table.Cell>{item.prevAbbr}</Table.Cell>
                                <Table.Cell>{item.prev.Amount}</Table.Cell>
                                <Table.Cell>{item.prev.payPeriodEnd}</Table.Cell>
                                <Table.Cell>{item.prev.Entry_Deposit_Date}</Table.Cell>
                                <Table.Cell>{item.prev.ProcDate}</Table.Cell>


                                <Table.Cell>{item.liveAbbr}</Table.Cell>
                                <Table.Cell>{item.live.Amount}</Table.Cell>
                                <Table.Cell>{item.live.ProcDate}</Table.Cell>
                            </Table.Row>
                        ))
                    )}
                </Table.Body>
            </Table>
        </Segment>
    );
    const renderTable = (data, title) => (
        <Segment>
            <Header as="h3">{title}</Header>
            <Table celled striped>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Abbr</Table.HeaderCell>
                        <Table.HeaderCell>PatNum</Table.HeaderCell>
                        <Table.HeaderCell>PayNum</Table.HeaderCell>
                        <Table.HeaderCell>Amount</Table.HeaderCell>
                        <Table.HeaderCell>Category</Table.HeaderCell>
                        <Table.HeaderCell>ProcDate</Table.HeaderCell>

                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {data.length === 0 ? (
                        <Table.Row>
                            <Table.Cell colSpan="3" textAlign="center">
                                No records found.
                            </Table.Cell>
                        </Table.Row>
                    ) : (
                        data.map((item, idx) => (
                            <Table.Row key={idx}>
                                <Table.Cell>{item.abbr}</Table.Cell>
                                <Table.Cell>{item.PatNum}</Table.Cell>
                                <Table.Cell>{item.paynum}</Table.Cell>
                                <Table.Cell>{item.Amount}</Table.Cell>
                                <Table.Cell>{categoryNames[item.Category]}</Table.Cell>
                                <Table.Cell>{item.ProcDate}</Table.Cell>
                            </Table.Row>
                        ))
                    )}
                </Table.Body>
            </Table>
        </Segment>
    );

    return (
        <Modal
            open={true}
            onClose={() => handlePreviousPayDetailsModal(false)}
            centered={false}
            closeIcon
            size={'large'}
        >
            <Modal.Content>
                <Container style={{marginTop: '2rem'}}>
                    <Header as="h2">Previous Pay Changes</Header>
                    <Grid divided='vertically'>
                        <Grid.Row columns={2}>
                            <Grid.Column>
                                <Header as={'h4'}>{providerPayByPractice.doctorName}</Header>
                            </Grid.Column>
                            <Grid.Column>
                                <Header as={'h4'}>Contract Type: {providerPayByPractice.contractType}</Header>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                    {payData.Provider_Change && renderProviderChangeTable(payData.Provider_Change, 'Provider Changes')}
                    {payData.ADD && renderTable(payData.ADD, 'New Additions')}
                    {payData.DELETE && renderTable(payData.DELETE, 'Delete')}
                </Container>
            </Modal.Content>
        </Modal>

    );
};

export default PreviousPayDataDetails;
